import GridInterface from '../../Interfaces/GridInterface';
import { UserType } from './Interfaces/UserType';


const grid: GridInterface[] = [
    { name: 'Id', label: 'Id', align: 'center', field: (row: UserType) => row.id, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'Name', label: 'Nome', align: 'center', field: (row: UserType) => row.name, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'Tenant', label: 'Tenant', align: 'center', field: (row: UserType) => row.tenantName, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'Tenant id', label: 'Tenant id', align: 'center', field: (row: UserType) => row.tenantId, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'WebPage', label: 'WebPage', align: 'center', field: (row: UserType) => row.webPage, sortable: true, visible: true, searchable: true, disable: true }
]

export default grid;